import React, { useRef } from 'react';
import s from './NewJob.module.scss';
import Ticker from '../../components/layout/Ticker/Ticker';
import BenefitsSlider from './BenefitsSlider/BenefitsSlider';
import VideoSlider from './VideoSlider/VideoSlider';
import GridCards from './GridCards/GridCards';
import TeamSlider from './TeamSlider/TeamSlider';
import HonoraryEmployeesSlider from './HonoraryEmployeesSlider/HonoraryEmployeesSlider';
import { DoskiIcon } from '../../assets/icons/job';
import PhotoTicker from './PhotoTicker/PhotoTicker';
import JobApplicationForm from './JobApplicationForm/JobApplicationForm';


const NewJob = () => {
  const sectionRef = useRef(null);

  const scrollToSection = () => {
    sectionRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className={s.newJobPage}>
      <div className={s.blackBg}></div>

      <section className={s.tickerWithTitle}>
        <PhotoTicker />
        <div className={`${s.mainTitle} ${s.container}`}>
          <h1 className={`${s.mainH1}`}>
            <p className={s.firstPartTitle}>СТАНЬ ЧАСТЬЮ</p>
            <span className={s.secondPartTitle}>
              <p className={s.text}>Команды</p>
              {/* <p><DoskiIcon /></p> */}
              <DoskiIcon />

            </span>
          </h1>
          <button 
            className={s.greenButton}
            onClick={scrollToSection}
          >Заполнить анкету</button>
        </div>
      </section>

      {/*<section className={s.benefits}>*/}
      {/*  <Ticker name={"advantage"} style={{*/}
      {/*    color: 'white',*/}
      {/*  }}/>*/}
      {/*  <div className={`${s.container} ${s.containerSwiper}`}>*/}
      {/*    <BenefitsSlider />*/}
      {/*  </div>*/}
      {/*  <div className={s.br}></div>*/}
      {/*</section>*/}

      <section className={s.jobInDoski}>
        <div className={`${s.jobTitleWithSlider} ${s.container}`}>
          <div className={s.h1Button}>
            <h1 className={s.h1}>ПЛЮСЫ РАБОТЫ В DOSKI</h1>
          </div>

          <GridCards />
        </div>
        <div className={s.br}></div>
      </section>

      <section className={s.videos}>
        <div className={`${s.videosTitleWithSlider} ${s.container}`}>
          <h1 className={s.h1}>ПОЧЕМУ ВЫБИРАЮТ НАС</h1>
          {/* <h1 className={s.h1}>НАША ПОДДЕРЖКА</h1> */}
          <VideoSlider />
          <button 
            className={s.greenButton}
            onClick={scrollToSection}
          >Заполнить анкету</button>
        </div>
        <div className={s.br}></div>
      </section>



      <section className={s.team}>
        <div className={`${s.teamTitleWithSlider} ${s.container}`}>
          <h1 className={s.h1}>Команда</h1>
          <TeamSlider />
        </div>
        <div className={s.br}></div>
      </section>

      <section className={`${s.honoraryEmployees} ${s.container}`}>
        <h1 className={s.h1}>ЛИДЕРЫ КАРЬЕРНОГО РОСТА</h1>
        <HonoraryEmployeesSlider />
      </section>
      
      <section className={s.jobApplication} ref={sectionRef}>
        <div className={`${s.titleWithForm} ${s.container}`}>
          <div className={s.h1WithText}>
            <h1 className={s.h1}>ОСТАВЬТЕ ЗАЯВКУ</h1>
            <p className={s.text}>В ближайшее время мы свяжемся с Вами!</p>
          </div>
          <JobApplicationForm />
        </div>
      </section>
    </div>
  )
}

export default NewJob;